import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { EGiftComponent } from "./e-gift/e-gift.component";
import { GiftActivateComponent } from "./gift-activate/gift-activate.component";
import { GiftBalanceCheckComponent } from "./gift-balance-check/gift-balance-check.component";
import { GiftWalletCreatePassComponent } from "./gift-wallet-create-pass/gift-wallet-create-pass.component";

const routes: Routes = [
	{
		path: "",
		component: EGiftComponent,
	},
	{
		path: "balance",
		component: GiftBalanceCheckComponent,
	},
	{
		path: "activate/:transactionGuid",
		component: GiftActivateComponent,
	},
	{
		path: "wallet/:transactionGuid",
		component: GiftWalletCreatePassComponent,
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class GiftRoutingModule {}
